export const gameConfig = {
  minRows: 4,
  maxRows: 100,
  minCols: 4,
  maxCols: 100,
  sliderLength: 2
};
